import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, QueryIntentProjectArgs } from "types/generated";

export const GET_INTENT_PROJECT_POLICIES: TypedDocumentNode<
  { intentProject: Pick<IntentProject, "id" | "attachedPolicies" | "attachablePolicies"> },
  QueryIntentProjectArgs
> = gql`
  query GetIntentProjectPolicies($id: ID!) {
    intentProject(id: $id) {
      id
      attachedPolicies {
        id
        policyId
        policyName
        policyType
        policyBody
        policyLabels
        isAutoattached
      }
      attachablePolicies {
        id
        name
        type
      }
    }
  }
`;
